import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import {
  REDIRECT_BE,
  REDIRECT_IT,
  REDIRECT_FI,
  REDIRECT_SE,
  REDIRECT_FR,
  REDIRECT_NL,
  REDIRECT_DE,
  REDIRECT_HU,
  REDIRECT_ES,
  REDIRECT_PT,
  REDIRECT_CZ,
  REDIRECT_SK,
  REDIRECT_DK,
  REDIRECT_EE,
  REDIRECT_LV,
  REDIRECT_NO,
  REDIRECT_AT,
  REDIRECT_PL
} from '../../../assets/redirections';
import { Router } from '@angular/router';
import { SITE_INFO, SfSiteInfo, SfLocalizeService } from '@app/sf-lib/public_api';
import { isPlatformServer, PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class FacetNotFoundService {
  private readonly router = inject(Router);
  private readonly localize = inject(SfLocalizeService);
  private readonly platformLocation = inject(PlatformLocation);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly siteInfo = inject<SfSiteInfo>(SITE_INFO);

  public checkRedirection(url: string): void {
    if (isPlatformServer(this.platformId)) {
      if (this.siteInfo.lang.country === 'fr') {
        if (url.startsWith('/fr/')) {
          this.platformLocation.replaceState('state', 'redirect', url.slice(3));
        } else if (REDIRECT_FR[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_FR[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'be') {
        if (REDIRECT_BE[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_BE[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'nl') {
        if (REDIRECT_NL[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_NL[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'de') {
        if (REDIRECT_DE[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_DE[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'at') {
        if (REDIRECT_AT[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_AT[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'hu') {
        if (REDIRECT_HU[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_HU[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'es') {
        if (REDIRECT_ES[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_ES[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'pt') {
        if (REDIRECT_PT[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_PT[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'it') {
        if (REDIRECT_IT[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_IT[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'cz') {
        if (REDIRECT_CZ[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_CZ[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'sk') {
        if (REDIRECT_SK[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_SK[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'dk') {
        if (REDIRECT_DK[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_DK[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'se') {
        if (REDIRECT_SE[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_SE[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'no') {
        if (REDIRECT_NO[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_NO[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'fi') {
        if (REDIRECT_FI[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_FI[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'ee') {
        if (REDIRECT_EE[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_EE[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'lv') {
        if (REDIRECT_LV[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_LV[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
      if (this.siteInfo.lang.country === 'pl') {
        if (REDIRECT_PL[url]) {
          this.platformLocation.replaceState('state', 'redirect', REDIRECT_PL[url]);
        } else {
          this.router.navigate([this.localize.instant('/not-found')]);
        }
      }
    }
  }
}
